import { Injectable } from '@angular/core';

import { liteClient as algoliasearch } from 'algoliasearch/lite';
import InstantSearch from 'instantsearch.js/es/lib/InstantSearch';
import type { IndexWidget, Widget } from 'instantsearch.js';

const searchClient = algoliasearch(
  '8O7IGUKXAE',
  '432f402cbead904597be00d17797974b'
);

@Injectable({
  providedIn: 'root'
})
export class InstantSearchService {

  public instantSearchInstance: InstantSearch

  constructor(
    
  ) { 

    this.instantSearchInstance = new InstantSearch({
      searchClient,
      indexName: 'customers',
      future: { preserveSharedStateOnUnmount: true },
    });


  }

  start() {
    if(!this.instantSearchInstance.started){
      this.instantSearchInstance.start();
    }
  }

  addWidgets(widgets: Array<IndexWidget | Widget>) {
    this.instantSearchInstance.addWidgets(widgets);
  }

  removeWidgets(widgets: Array<IndexWidget | Widget>) {
    this.instantSearchInstance.removeWidgets(widgets);

   
  }

  removeAllListeners(){
    this.instantSearchInstance.removeAllListeners()
  }


}
